import React, { FC, useContext, useEffect, useState } from 'react';

import { TableCell, TableHead, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../../store';

import { useGetRoundLabel } from '../../../../../common/Hooks/useGetroundLabel';
import { useAssignResultsState } from '../../../Common/AssignResults/Context/AssignResults.context';
import { isHorse } from '../../../Common/ResultsTable/Utils/isHorse';
import { isStrokeplay } from '../../../Common/ResultsTable/Utils/isStrokeplay';
import { isTeamStrokeplay } from '../../../Common/ResultsTable/Utils/isTeamStrokeplay';
import { isCTP } from '../../../Common/ResultsTable/Utils/isCTP';
import { isScramble } from '../../../Common/ResultsTable/Utils/isScramble';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';

export const ResultsTableHead: FC = () => {
  const {
    horseRaceEliminatedResults,
    results,
    selectedCombination,
    skinsResults
  } = useAssignResultsState();

  const { adminEvents } = useContext(GlobalContext);

  const { eventId, roundId } = useRouteInfoState();

  const [getRoundLabel] = useGetRoundLabel(adminEvents, Number(eventId), Number(roundId));

  const [thereAreResults, setThereAreResults] = useState(false);

  useEffect(() => {
    setThereAreResults(
      results.length > 0 ||
        Object.keys(skinsResults).length > 0 ||
        (!!horseRaceEliminatedResults && !!horseRaceEliminatedResults.true)
    );
  }, [results, skinsResults, horseRaceEliminatedResults]);

  if (!selectedCombination) {
    return <></>;
  }

  return (
    <TableHead>
      <TableRow
        className={`table-subheader ${
          isHorse(selectedCombination) && thereAreResults ? 'hidden' : ''
        }`}
      >
        <TableCell colSpan={4}>
          <>
            {!isHorse(selectedCombination) && (
              <p className="flightName">
                {selectedCombination.flight ? selectedCombination.flight.name : 'All flights'}
              </p>
            )}

            {!thereAreResults && (
              <p className="noResults">There are no results or awards for this selection</p>
            )}
          </>
        </TableCell>
      </TableRow>

      {thereAreResults && (
        <TableRow className="table-header">
          <TableCell>
            {isStrokeplay(selectedCombination) || isScramble(selectedCombination) ? 'Pos' : 'Hole'}
          </TableCell>

          <TableCell>
            {isStrokeplay(selectedCombination)
              ? 'Player'
              : isHorse(selectedCombination)
              ? 'Players'
              : isScramble(selectedCombination)
              ? 'Team'
              : 'Winner'}
          </TableCell>

          {!isStrokeplay(selectedCombination) && (
            <TableCell colSpan={isHorse(selectedCombination) ? 3 : 1}>
              {isCTP(selectedCombination)
                ? 'Distance'
                : isScramble(selectedCombination)
                ? 'Total'
                : 'Score'}
            </TableCell>
          )}

          {!isHorse(selectedCombination) && (
            <>
              {!isTeamStrokeplay(selectedCombination) && (
                <TableCell>{isStrokeplay(selectedCombination) ? getRoundLabel() : ''}</TableCell>
              )}

              {(isStrokeplay(selectedCombination) || isTeamStrokeplay(selectedCombination)) && (
                <TableCell>Thru</TableCell>
              )}
            </>
          )}
        </TableRow>
      )}
    </TableHead>
  );
};
